// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ Import storage

const firebaseConfig = {
  apiKey: "AIzaSyBWUVCuiGneCTja0Xg2XMTdeyR91fXUF4E",
  authDomain: "digital-cemetery-9849c.firebaseapp.com",
  projectId: "digital-cemetery-9849c",
//  storageBucket: "digital-cemetery-9849c.appspot.com", // ✅ Corrected domain
  storageBucket: "gs://digital-cemetery-9849c.firebasestorage.app/",
  messagingSenderId: "550826125250",
  appId: "1:550826125250:web:86820da893060414c5985b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ Export storage
